module.exports = __webpack_public_path__ + "images/create-first-board/low-fidelity-card-back.dc72914ec7ff5c2e9df9.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/create-first-board/low-fidelity-card-back.svg
// module id = o3CT
// module chunks = 24